import { css } from 'styled-components';

const VisuallyHiddenStyles = css `
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

export { VisuallyHiddenStyles };
//# sourceMappingURL=VisuallyHidden.styles.js.map
